import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/thumbUpFilled.svg';

export const IconThumbUpFilled = createIconComponent(Icon);
